import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import PublicMarketingChrome from '../../components/PublicMarketingChrome';
import CgvDocument from './CgvDocument';
import { APP_NAME } from '../../constants';

const CgvPage = () => {
  const navigate = useNavigate();

  return (
    <PublicMarketingChrome
      helmetTitle={`CGV — ${APP_NAME}`}
      description={`Conditions Générales de Vente de ${APP_NAME} : prix, paiement, garanties, rétractation et annulation.`}
      kicker="Légal"
      title="Conditions Générales de Vente (CGV)"
      subtitle="Les règles applicables à nos prestations de plomberie, pour les particuliers et les professionnels."
    >
      <CgvDocument />
      <div className="text-center mt-10">
        <Button
          variant="default"
          size="lg"
          iconName="Calendar"
          onClick={() => navigate('/service-booking-wizard')}
        >
          Réserver une intervention
        </Button>
      </div>
    </PublicMarketingChrome>
  );
};

export default CgvPage;
